import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, map } from 'rxjs';

import { LabelSelectionImpactDialogComponent } from './label-selection-impact-dialog.component';
import { LabelSelectionImpactDialogData } from './label-selection-impact-dialog.types';

/**
 * Abre la advertencia de impacto del control logístico y responde si el usuario confirmó.
 *
 * Existe para que los dos disparadores — apagar la selección manual de etiquetas y cambiar la
 * unidad de control logístico — compartan una línea en lugar de dos copias del mismo
 * `dialog.open(...).afterClosed()`, y para que ninguno de los dos tenga que conocer el
 * componente del diálogo.
 */
@Injectable({ providedIn: 'root' })
export class LabelSelectionImpactDialogService {
  private readonly dialog = inject(MatDialog);

  /** Emite una vez: `true` para aplicar el cambio, `false` si se canceló o se descartó. */
  confirm(data: LabelSelectionImpactDialogData): Observable<boolean> {
    return this.dialog
      .open<LabelSelectionImpactDialogComponent, LabelSelectionImpactDialogData, boolean>(
        LabelSelectionImpactDialogComponent,
        {
          data,
          width: '95vw',
          maxWidth: '640px',
          // El backdrop no es un "sí" accidental: descartar deja la configuración como estaba.
          autoFocus: false,
        }
      )
      .afterClosed()
      .pipe(map((confirmed) => confirmed === true));
  }
}
